import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router'; import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { RiskManagementService } from 'src/app/_services/risk-management/risk-management.service';
import { CircularGaugeComponent, ILoadedEventArgs } from '@syncfusion/ej2-angular-circulargauge';
import { ActionItemsGridRowRendererComponent } from '../../../_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { CommonModule } from '@angular/common'
import { ProjectService } from 'src/app/_services/project/project.service';
@Component({
  selector: 'app-risk-management',
  templateUrl: './risk-management.component.html',
  styleUrls: ['./risk-management.component.scss']
})
export class RiskManagementComponent implements OnInit {
  riskForm
  form: FormGroup;
  tenantId: string;
  paramsid: any;
  jsonData: any;
  selectedRow: any;
  currentUser: any;
  isAdministrator: boolean = false;
  // row data and column definitions  
  rowData: any;
  graphTempData: any;
  riskManagementOption: any;
  riskManagementOptionName = [];
  strategy = [];
  riskCategory = [];
  impactOnCustomer = [];
  highestImpactOn = [];
  probability = [];
  severity = [];
  public columnDefs: ColDef[];
  modeAction: number = 1 //1 - create // 2 - update
  // gridApi and columnApi  
  private api: GridApi;
  private columnApi: ColumnApi;
  defaultColDef: any;
  rowSelection: any
  orm: FormGroup;
  emailPattern = "^[a-z0-9._%+-]+\\.[a-z]{2,4}$";
  gridLength = 0;
  sampleGridFrameworkComponents: any;
  selectedCheckboxData = [];
  projectDropdownList: any[] = [];
  deleteConfirmationMsg = 'Are you sure you want to delete'
  //Gauge Graph Custom Variable
  lowPercentageCount = 0;
  moderatePercentageCount = 0;
  highPercentageCount = 0;
  catastropicPercentageCount = 0;
  lowPercentage: any;
  moderatePercentage: any;
  highPercentage: any;
  catastropicPercentage: any;
  pointer: any;
  //Gauge Graph
  @ViewChild('range')
  public circulargauge: CircularGaugeComponent;
  public lineStyle: object;
  public labelStyle: object;
  public majorTicks: object;
  public minorTicks: object;
  public tail: object;
  public pointerCap: object;
  public annotaions: object;
  public legendSettings: object;
  //Varaible for Risk Management tableGraph
  public riskManagement = [
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0]
  ];


  constructor(
    private riskManagementService: RiskManagementService,
    private route: ActivatedRoute,
    private router: Router,
    private storageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private projectService: ProjectService,
  ) {
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };
    this.rowSelection = 'multiple';
    this.columnDefs = this.createColumnDefs();

    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent
    };

    this.form = this.formBuilder.group({
      file: ['', Validators.required]
    });

    this.riskForm = new FormGroup({
      evaluation: new FormControl(''),
      status: new FormControl(''),
      dateFound: new FormControl('', Validators.required),
      description: new FormControl(''),
      highestImpactOn: new FormControl(''),
      impactOnCustomerSatisfaction: new FormControl(''),
      riskCategory: new FormControl('', Validators.required),
      strategy: new FormControl(''),
      additionalCost: new FormControl(''),
      delay: new FormControl(''),
      countermeasure: new FormControl(''),
      dueDate: new FormControl(''),
      responsible: new FormControl(''),
      reductionOfCost: new FormControl(''),
      reductionOfDelay: new FormControl(''),
      dateChecked: new FormControl(''),
      result: new FormControl(''),
      severity: new FormControl(''),
      probability: new FormControl(''),
      projectId: new FormControl(''),
      projectName: new FormControl(''),
    });
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.tenantId = this.storageService.get('tenantId');
    this.isAdministrator = this.currentUser.roles.includes('RoleAdministrator');
    this.getAllRiskManagements();
    this.getAllRiskManagementOptions();
    this.getProjectsData();

    //Gauge Graph
    this.lineStyle = {
      width: 10, color: 'transparent'
    };

    // Initializing LabelStyle
    this.labelStyle = {
      position: 'Inside', useRangeColor: false,
      font: { size: '12px', fontFamily: 'Roboto', fontStyle: 'Regular' }
    };

    this.majorTicks = {
      height: 10, offset: 5, color: '#9E9E9E'
    };

    this.minorTicks = {
      height: 0
    };

    this.tail = {
      length: '18%', color: '#757575'
    };

    this.pointerCap = {
      radius: 7, color: '#757575'
    };

    this.annotaions = [{
      content: '<div><span style="font-size:14px; color:#9E9E9E; font-family:Regular">Speedometer</span></div>',
      radius: '30%', angle: 0, zIndex: '1'
    }, {
      content: '<div><span style="font-size:24px; color:#424242; font-family:Regular">65 MPH</span></div>',
      radius: '40%', angle: 180, zIndex: '1'
    }];
    this.lineStyle = {
      useRangeColor: true
    };
    this.majorTicks = {
      useRangeColor: true
    };
    this.minorTicks = {
      useRangeColor: true
    };
    this.legendSettings = {
      visible: true,
    };
  }

  getProjectsData() {
    if(this.isAdministrator){
      this.projectService.getProjects().subscribe((response: any) => {
        for (let item of response) {
          this.projectDropdownList.push(`${item.id} . ${item.projectName}`);
        }
      });
    } else{
      let ignoreArchived : boolean = false;
      this.projectService.getProjectByUserId(this.currentUser.id, ignoreArchived).subscribe((response: any) => {
        for (let item of response) {
          this.projectDropdownList.push(`${item.id} . ${item.projectName}`);
        }
      });
    }
  }

  getAllRiskManagementOptions(){
    // Get all the Risk Management Options for dropdwon fields
    this.riskManagementService.getAllRiskManagementOptions().subscribe((response: any) => {
      this.riskManagementOption = response.result;
      for (var i = 0; i < this.riskManagementOption.length; i++) {
        if (this.riskManagementOptionName.indexOf(this.riskManagementOption[i]["optionName"]) == -1) {
          this.riskManagementOptionName.push(this.riskManagementOption[i]["optionName"]);
        }
      }

      //for (var j = 0; j < this.riskManagementOptionName.length; j++) {
      for (var i = 0; i < this.riskManagementOption.length; i++) {
        if (this.riskManagementOption[i]["optionName"] === "Highest Impact on") {
          this.highestImpactOn.push(this.riskManagementOption[i]);
        }

        if (this.riskManagementOption[i]["optionName"] == "Impact on customer") {
          this.impactOnCustomer.push(this.riskManagementOption[i]);
        }
        if (this.riskManagementOption[i]["optionName"] == "Risk Category") {
          this.riskCategory.push(this.riskManagementOption[i]);
        }
        if (this.riskManagementOption[i]["optionName"] == "Strategy") {
          this.strategy.push(this.riskManagementOption[i]);
        }
        if (this.riskManagementOption[i]["optionName"] == "Probalility of occurance") {
          this.probability.push(this.riskManagementOption[i]);
        }
        if (this.riskManagementOption[i]["optionName"] === "Severity") {
          this.severity.push(this.riskManagementOption[i]);
        }
      }
    });
  }

  getAllRiskManagements(){
    this.riskManagementService.getAllRiskManagements().subscribe((response: any) => {
      this.rowData = response.result;
      this.graphTempData = this.rowData;
      for (let x = 0; x < this.graphTempData.length; x++) {
        let severity = this.graphTempData[x]["severity"];
        let probability = this.graphTempData[x]["probability"];
        //Check and generate  a count for the different risk level
        if (severity == "Low" && probability == "Very Probable(>50%)") {
          this.riskManagement[0][0] = this.riskManagement[0][0] + 1;
        }
        if (severity == "Low" && probability == "Probable(<50%)") {
          this.riskManagement[0][1] = this.riskManagement[0][1] + 1;
        }
        if (severity == "Low" && probability == "Perhaps(<10%)") {
          this.riskManagement[0][2] = this.riskManagement[0][2] + 1;
        }
        if (severity == "Low" && probability == "Improbably(<5%)") {
          this.riskManagement[0][3] = this.riskManagement[0][3] + 1;
        }
        //Moderate
        if (severity == "Moderate" && probability == "Very Probable(>50%)") {
          this.riskManagement[1][0] = this.riskManagement[1][0] + 1;
        }
        if (severity == "Moderate" && probability == "Probable(<50%)") {
          this.riskManagement[1][1] = this.riskManagement[1][1] + 1;
        }
        if (severity == "Moderate" && probability == "Perhaps(<10%)") {
          this.riskManagement[1][2] = this.riskManagement[1][2] + 1;
        }
        if (severity == "Moderate" && probability == "Improbably(<5%)") {
          this.riskManagement[1][3] = this.riskManagement[1][3] + 1;
        }
        //High
        if (severity == "High" && probability == "Very Probable(>50%)") {
          this.riskManagement[2][0] = this.riskManagement[1][0] + 1;
        }
        if (severity == "High" && probability == "Probable(<50%)") {
          this.riskManagement[2][1] = this.riskManagement[1][1] + 1;
        }
        if (severity == "High" && probability == "Perhaps(<10%)") {
          this.riskManagement[2][2] = this.riskManagement[1][2] + 1;
        }
        if (severity == "High" && probability == "Improbably(<5%)") {
          this.riskManagement[2][3] = this.riskManagement[1][3] + 1;
        }
        //Catastropic
        if (severity == "Catastropic" && probability == "Very Probable(>50%)") {
          this.riskManagement[3][0] = this.riskManagement[1][0] + 1;
        }
        if (severity == "Catastropic" && probability == "Probable(<50%)") {
          this.riskManagement[3][1] = this.riskManagement[1][1] + 1;
        }
        if (severity == "Catastropic" && probability == "Perhaps(<10%)") {
          this.riskManagement[3][2] = this.riskManagement[1][2] + 1;
        }
        if (severity == "Catastropic" && probability == "Improbably(<5%)") {
          this.riskManagement[3][3] = this.riskManagement[1][3] + 1;
        }
      }
      for (let x = 0; x < this.graphTempData.length; x++) {
        let severity = this.graphTempData[x]["severity"];
        if (severity == "Low") {
          this.lowPercentageCount++;
        }
        if (severity == "Moderate") {
          this.moderatePercentageCount++;
        }
        if (severity == "High") {
          this.highPercentageCount++;
        }
        if (severity == "Catastropic") {
          this.catastropicPercentageCount++;
        }
      }

      // console.log('this.riskManagement', this.riskManagement);

      const total = this.lowPercentageCount + this.moderatePercentageCount + this.highPercentageCount + this.catastropicPercentageCount;
      if (total === 0) {
        this.lowPercentage = 25;
        this.moderatePercentage = 50;
        this.highPercentage = 75;
        this.catastropicPercentage = 100;
        return;
      }

      this.lowPercentage = Math.round((this.lowPercentageCount / total) * 100);
      this.moderatePercentage = Math.round((this.moderatePercentageCount / total) * 100);
      this.highPercentage = Math.round((this.highPercentageCount / total) * 100);
      this.catastropicPercentage = Math.round((this.catastropicPercentageCount / total) * 100);
      
      // this.lowEnd = this.lowPercentage;
      this.moderatePercentage = this.lowPercentage + this.moderatePercentage;
      this.highPercentage = this.moderatePercentage + this.highPercentage;
      this.catastropicPercentage = 100;
      this.pointer = this.moderatePercentage;

      //Caculate percentage for low
      // this.lowPercentage = (this.lowPercentageCount / (this.lowPercentageCount + this.moderatePercentageCount + this.highPercentageCount + this.catastropicPercentageCount) * 100).toFixed();
      // this.moderatePercentage = (this.moderatePercentageCount / (this.lowPercentageCount + this.moderatePercentageCount + this.highPercentageCount + this.catastropicPercentageCount) * 100).toFixed();
      // this.highPercentage = (this.highPercentageCount / (this.lowPercentageCount + this.moderatePercentageCount + this.highPercentageCount + this.catastropicPercentageCount) * 100).toFixed();
      // this.catastropicPercentage = (this.catastropicPercentageCount / (this.lowPercentageCount + this.moderatePercentageCount + this.highPercentageCount + this.catastropicPercentageCount) * 100).toFixed();
      // if (this.lowPercentage == 0) { this.lowPercentage = 1 }
      // if (this.moderatePercentage == 0) { this.moderatePercentage = this.lowPercentage }
      // if (this.highPercentage == 0) { this.highPercentage = this.moderatePercentage }
      // if (this.catastropicPercentage == 0) { this.catastropicPercentage = this.highPercentage }

    });
  }

  getRiskManagements() {
    this.riskManagementService.getAllRiskManagements().subscribe((response: any) => {
      this.rowData = response.result;
    });
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
  onGridReady(params): void {
    this.api = params.api;
    console.log('qqqq', this.api)
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }

  // create column definitions  
  private createColumnDefs() {
    return [
      //   {
      //   headerName: '', 
      //   width: 150,
      //   field: 'delete', 
      //   cellRenderer: "actionRowRendererComponent",
      //   cellRendererParams: {
      //     onClick: this.performGridActionItem.bind(this),
      //     deleteRequired: true,
      //   }
      // },
      {
        headerName: 'Evaluation',
        field: 'evaluation',
        filter: true,
        editable: false,
        sortable: true,
        headerCheckboxSelection: this.isFirstColumn,
        checkboxSelection: this.isFirstColumn,
      },
      {
        headerName: 'Project',
        valueGetter: function(params){
          return params.data.projectId + ' . ' + params.data.projectName;
        },
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Status',
        field: 'status',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'DateFound',
        field: 'dateFound',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Highest Impact On',
        field: 'highestImpactOn',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Severity',
        field: 'severity',
        cellStyle: (params) => {
          if (params.value === 'Low' || params.value === 'Low') {
            return { color: 'green', 'font-weight': 'bold' };
          } else if (params.value === 'Moderate' || params.value === 'Moderate') {
            return { color: '#FFC107', 'font-weight': 'bold' };
          } else if (params.value === 'Catastropic' || params.value === 'Catastropic') {
            return { color: '#8b0000', 'font-weight': 'bold' };
          } else if (params.value === 'High' || params.value === 'High') {
            return { color: 'red', 'font-weight': 'bold' };
          }
          return null;
        },
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Probability',
        field: 'probability',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: 'Description',
        field: 'description',
        filter: true,
        editable: false,
        sortable: true
      }]
  }

  onSelectionChanged(event) {
    this.selectedCheckboxData = []
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data)
    }
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }


  createRiskManagements() {
    let details = {
      evaluation: this.riskForm.get('evaluation').value,
      projectId: this.riskForm.get('projectId').value.split(' . ')[0],
      status: this.riskForm.get('status').value,
      dateFound: this.riskForm.get('dateFound').value,
      description: this.riskForm.get('description').value,
      highestImpactOn: this.riskForm.get('highestImpactOn').value,
      impactOnCustomerSatisfaction: this.riskForm.get('impactOnCustomerSatisfaction').value,
      riskCategory: this.riskForm.get('riskCategory').value,
      strategy: this.riskForm.get('strategy').value,
      additionalCost: this.riskForm.get('additionalCost').value,
      delay: this.riskForm.get('delay').value,
      countermeasure: this.riskForm.get('countermeasure').value,
      dueDate: this.riskForm.get('dueDate').value,
      responsible: this.riskForm.get('responsible').value,
      reductionOfCost: this.riskForm.get('reductionOfCost').value,
      reductionOfDelay: this.riskForm.get('reductionOfDelay').value,
      dateChecked: this.riskForm.get('dateChecked').value,
      result: this.riskForm.get('result').value,
      severity: this.riskForm.get('severity').value,
      probability: this.riskForm.get('probability').value,
    }

    this.riskManagementService.createRiskManagements(details).subscribe((response: any) => {
      console.log("response: ", response);

      // update grid after creating new lead & close the modal
      this.api.applyTransaction({ add: [response] });
      this.getRiskManagements();
      $('#closeModalRiskManagement').trigger("click");

    });
  }

  performGridActionItem(params) {
    if (params.event.currentTarget.value == 'delete') {
      this.deleteGridRow(params);
    }
  }

  private deleteGridRow(params: any) {
    this.riskManagementService.deleteRiskManagements(params.params.data.id).subscribe(() => {
      var selectedData = params.params.data;
      this.api.applyTransaction({ remove: [selectedData] });
    });
  }

  editOpenModal() {
    this.modeAction = 2;
    this.riskForm.patchValue(this.selectedCheckboxData[0]);
    this.riskForm.value.projectId = this.selectedCheckboxData[0].projectId + ' . ' + this.selectedCheckboxData[0].projectName;
    this.riskForm.patchValue(this.riskForm.value);
  }

  createOpenModal() {
    this.modeAction = 1;
    this.riskForm.reset();
    this.riskForm.patchValue({
      evaluation: '',
      projectId: '',
      status: '',
      dateFound: '',
      description: '',
      highestImpactOn: '',
      impactOnCustomerSatisfaction: '',
      riskCategory: '',
      strategy: '',
      additionalCost: '',
      delay: '',
      countermeasure: '',
      dueDate: '',
      responsible: '',
      reductionOfCost: '',
      reductionOfDelay: '',
      dateChecked: '',
      result: '',
      severity: '',
      probability: '',
    })
  }

  updateRiskManagements(id) {
    let details = {
      evaluation: this.riskForm.get('evaluation').value,
      projectId: this.riskForm.get('projectId').value.split(' . ')[0],
      status: this.riskForm.get('status').value,
      dateFound: this.riskForm.get('dateFound').value,
      description: this.riskForm.get('description').value,
      highestImpactOn: this.riskForm.get('highestImpactOn').value,
      impactOnCustomerSatisfaction: this.riskForm.get('impactOnCustomerSatisfaction').value,
      riskCategory: this.riskForm.get('riskCategory').value,
      strategy: this.riskForm.get('strategy').value,
      additionalCost: this.riskForm.get('additionalCost').value,
      delay: this.riskForm.get('delay').value,
      countermeasure: this.riskForm.get('countermeasure').value,
      dueDate: this.riskForm.get('dueDate').value,
      responsible: this.riskForm.get('responsible').value,
      reductionOfCost: this.riskForm.get('reductionOfCost').value,
      reductionOfDelay: this.riskForm.get('reductionOfDelay').value,
      dateChecked: this.riskForm.get('dateChecked').value,
      result: this.riskForm.get('result').value,
      severity: this.riskForm.get('severity').value,
      probability: this.riskForm.get('probability').value,
    }

    this.riskManagementService.updateRiskManagements(details, this.selectedCheckboxData[0].id).subscribe(res => {
      this.getRiskManagements();
      this.selectedCheckboxData = []
      $('#closeModalRiskManagement').trigger("click");
    })
  }

  deleteOpenModal() {
    this.deleteConfirmationMsg = 'Are you sure you want to delete'
    for (let i in this.selectedCheckboxData) {
      if (+i === 0) this.deleteConfirmationMsg += ` ${this.selectedCheckboxData[i].evaluation}`;
      else if (this.selectedCheckboxData.length === +i + 1) this.deleteConfirmationMsg += ` & ${this.selectedCheckboxData[i].evaluation}`;
      else this.deleteConfirmationMsg += ` , ${this.selectedCheckboxData[i].evaluation}`;
    }
  }

  deleteRiskManagements(id) {
    this.riskManagementService.deleteRiskManagements(this.selectedCheckboxData[0].id).subscribe(() => {
      this.getRiskManagements();
      this.selectedCheckboxData = []
      $('#closeModalDeleteRiskManagement').trigger("click");
    });
  }

  // to open delete modal
  open(item) {
    this.selectedRow = item;

  }

  // to open edit modal
  openEdit(item) {
    this.selectedRow = item;
    this.riskForm.patchValue(item);

  }


  // getter for easy access to form fields
  get f() {
    return this.riskForm.controls;
  }

}
